import { checknames, checkpoints } from "../../../../utils/dummy";
import LoadingIcon from "../../../../components/shared/LoadingIcon";
import { useEffect, useState } from "react";
import Station from "./Station";
import { CgMenuGridR } from "react-icons/cg";

export default function WallVisit({ visits, isLoading }: any) {
  const getData = () => {
    const groupedData = visits?.reduce((acc: any, item: any) => {
      const stationId = item.station.name;

      if (!acc[stationId]) {
        acc[stationId] = [];
      }
      acc[stationId].order = checkpoints[item?.station?.name];
      acc[stationId].name = checknames[item?.station?.name];
      acc[stationId].push(item);
      return acc;
    }, {});

    const stations = Object.keys(groupedData).map((stationId) => ({
      stationId,
      name: groupedData[stationId].name,
      data: groupedData[stationId],
      order: groupedData[stationId].order,
    }));

    stations.sort((a: any, b: any) => {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    });

    return stations;
  };

  const data = getData();

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextIndex = () => {
    const newIndex = (currentIndex + 1) % data?.length;
    setCurrentIndex(newIndex);
  };

  const prevIndex = () => {
    const newIndex =
      currentIndex === 0 ? data?.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToIndex = (index: any) => {
    setCurrentIndex(index);
  };


    useEffect(() => {
      const interval = setInterval(() => {
        nextIndex();
      }, 5000);

      return () => {
        clearInterval(interval);
      };
    }, [currentIndex]);

  if (isLoading) {
    return (
      <div className="flex justify-center bg-white">
        <LoadingIcon />
      </div>
    );
  }

  return (
    <div className=" bg-white">
      <div className="grid grid-cols-12 gap-x-2">
        <div className="col-span-2 bg-gray-50 mt-1">
          {data?.map((station: any, index: number) => {
            if (station?.stationId !== "Main Gate") {
              return (
                <button
                  key={index}
                  className={`flex items-center flex-1 w-full p-2 text-xl py-4 ${
                    index === currentIndex
                      ? "border-l-4 border-toyota bg-red-100 text-black"
                      : "border-l-4 border-white"
                  }`}
                  onClick={() => goToIndex(index)}
                >
                  <div className="">
                    <CgMenuGridR />
                  </div>
                  <div>{station?.name}</div>
                </button>
              );
            }
          })}
        </div>

        <div className="col-span-10 h-screen">
            <Station station={data[currentIndex]} />
        </div>
      </div>
    </div>
  );
}
